import React, { useState, useEffect } from 'react'
import CircularProgressWithLabel from './CircularProgressWithLabel'
import useStopwatch from '../effects/useStopwatch'
import pink from '@material-ui/core/colors/pink';
import { LinearProgress } from '@material-ui/core'

export default function QuizTimer(props) {
  const { color, linear, questionId, timeAllowed = 15 } = props
  const timeRemaining = useStopwatch({
    id: questionId,
    seconds: timeAllowed,
    resolution: props.resolution,
    alarmThreshold: Math.floor(timeAllowed / 3),
    onAlarm: props.onAlarm
  })

  return (
    <LinearProgress
      variant="determinate"
      value={100 - ((timeAllowed - timeRemaining) / timeAllowed * 100.0)}
      color="secondary"
      style={props.style}
    />
  )
}